import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import Policy from "../../components/Policy/Policy";

function Security() {
    return (
        <div>
            <Header showSignIn={true} dark={true} />
            <main>
                <Policy title={"Security at Keel Mind"}>
                    <div>
                        <h2>Data Security</h2>
                        <p>
                            Keel Mind Inc. encrypts data at rest and in transit
                            for all of our customers.
                        </p>
                    </div>
                    <div>
                        <h2>Application Security</h2>
                        <p>
                            Keel Mind Inc. regularly engages security experts
                            for third-party penetration tests and vulnerability
                            scans. These Third-party testers evaluate the
                            running application, and the deployed environment.
                        </p>
                        <p>
                            Keel Mind Inc. also uses high-quality static
                            analysis industry leading tooling provided by
                            Aquasec. It is a comprehensive suite that ensures
                            the security of our product at every step of the
                            development process
                        </p>
                    </div>
                    <div>
                        <h2>Infrastructure Security</h2>
                        <p>
                            Keel Mind Inc. uses Medstack.co to host our
                            application. We make full use of the security
                            products embedded within the Medstack ecosystem.
                            MedStack is the only solution that combines the
                            power of a platform with built-in security and
                            provable compliance.
                        </p>
                        <p>
                            Data and services are domiciled in the location
                            determined by our clients for regulatory compliance.
                        </p>
                    </div>
                </Policy>
            </main>
            <Footer />
        </div>
    );
}

export default Security;
